// src/pages/ServicesPage.js (CÓDIGO FINAL MIGRADO A REACT ROUTER)

import React from 'react';
// 🛑 CAMBIO CRÍTICO: Importar useNavigate y Link
import { useNavigate, Link } from 'react-router-dom'; 
import { FaArrowLeft, FaGavel, FaFileInvoiceDollar, FaBuilding, FaLandmark, FaArrowRight } from 'react-icons/fa';
import './ServicesPage.css';

const WHATSAPP_NUMBER = '14078738172';
const WHATSAPP_MESSAGE_SERVICES = 'Hola, estoy viendo la cartera de servicios y me gustaría agendar una consulta personalizada.';
const WHATSAPP_LINK_SERVICES = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE_SERVICES)}`;

const SERVICES_DATA = [
    {
        icon: FaGavel,
        title: "Derecho Mercantil",
        description: "Ofrecemos un amplio rango de servicios en derecho mercantil, diseñados para satisfacer las necesidades de empresas y emprendedores. Incluye constitución, fusión, escisión, liquidación de empresas y contratos mercantiles.",
        // Usaremos esta ruta para Link
        route: '/servicios/derecho-mercantil' 
    },
    {
        icon: FaFileInvoiceDollar,
        title: "Servicios Contables y Financieros",
        description: "Servicios financieros y contables integrales para ayudar a nuestros clientes a gestionar sus obligaciones fiscales y optimizar su situación financiera. Incluye planificación fiscal, auditoría y análisis de riesgos.",
        route: '/servicios/contabilidad-finanzas'
    },
    {
        icon: FaLandmark,
        title: "Derecho Civil",
        description: "Servicio completo en derecho civil, diseñado para atender diversas necesidades legales, incluyendo derecho sucesoral (herencias), derecho de propiedad y redacción de contratos civiles complejos.",
        route: '/servicios/derecho-civil'
    },
    {
        icon: FaBuilding,
        title: "Avalúos (Perito Avaluador)",
        description: "Servicios profesionales de perito avaluador, especializados en la determinación del valor de diversos activos. Realizamos avalúos precisos de inmuebles (terrenos, residencias, galpones), empresas, maquinaria, equipos y avalúos agrícolas e industriales.",
        route: '/servicios/avaluos'
    },
];

// 🛑 Componente ServiceCard migrado para usar <Link>
const ServiceCard = ({ icon: Icon, title, description, route }) => (
    <div className="service-card-detail">
        <Icon className="service-icon-detail" />
        <h3>{title}</h3>
        <p>{description}</p>
        
        {/* Usamos Link para una navegación interna correcta */}
        <Link to={route} className="ver-mas-button">
            Ver más... <FaArrowRight style={{marginLeft: '5px'}}/>
        </Link>
    </div>
);

// 🛑 Eliminamos la prop setActivePage
const ServicesPage = () => {
    const navigate = useNavigate(); // Inicializamos navigate
    
    // Función de redirección a WhatsApp para el CTA
    const handleCtaClick = () => {
        window.open(WHATSAPP_LINK_SERVICES, '_blank');
    };
    
    // Función de redirección para el botón "Volver"
    const handleBackClick = () => {
        navigate('/');
    };

    return (
        <section id="services-page" className="page-container services-container">
            
            <div className="services-header">
                <h1>Servicios Integrales: Áreas de Especialización</h1>
                <p>En Giovanni Scarvaci & Asociados, ofrecemos un conjunto integral de servicios diseñados para satisfacer las necesidades legales, de economía, finanzas, contables y de avalúos de su empresa asi tambien para Personas naturales.</p>
            </div>
            
            <div className="services-grid">
                {SERVICES_DATA.map((service, index) => (
                    // 🛑 Ya no pasamos setActivePage
                    <ServiceCard 
                        key={index} 
                        {...service} 
                    />
                ))}
            </div>
            
            <section className="cta-services-page">
                <h2>¿Necesitas Asesoría Personalizada?</h2>
                <p>Agenda una consulta con nuestros expertos para discutir tu caso específico.</p>
                <button className="cta-button primary" onClick={handleCtaClick}>
                    Agendar Consulta
                </button>
            </section>
            
            {/* 🛑 Botón "Volver al Inicio" migrado a navigate */}
            <button className="back-button" onClick={handleBackClick}>
                <FaArrowLeft /> Volver al Inicio
            </button>
        </section>
    );
};

export default ServicesPage;